import { render } from "./AppPersonalAgreementDialog.vue?vue&type=template&id=484a6b30&ts=true"
import script from "./AppPersonalAgreementDialog.vue?vue&type=script&lang=ts"
export * from "./AppPersonalAgreementDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__